<template>
  <div id="main-content">
    <a-card title="内购汇总"
            style="width: 100%;flex: 1;overflow-y: hidden;border-radius: 5px"
            :bodyStyle="{padding:'0',overflowY:'hidden',height: 'calc(100% - 65px)'}" >
      <div slot="extra">
        <!--<a-select v-model="product" style="width: 240px" allowClear showSearch-->
        <!--          :maxTagCount="1" placeholder="请选择产品"-->
        <!--          optionFilterProp="label"-->
        <!--          @change="changeDate()">-->
        <!--  <a-select-option v-for="productItem in $store.getters.getAppAll"-->
        <!--                   :label="productItem.app_name"-->
        <!--                   :value="productItem.app_id"-->
        <!--                   :key="productItem.app_id">-->
        <!--    <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">-->
        <!--    {{productItem.app_name}}-->
        <!--  </a-select-option>-->
        <!--</a-select>-->
        <span style="color: red">iOS：唯一时区&nbsp;&nbsp;&nbsp;&nbsp;Android：UTC时区</span>
        <a-select v-model="platform" style="width: 200px" allowClear
                  placeholder="请选择平台"
                  @change="changePlatform">
          <a-select-option value="iOS" key="ios">iOS</a-select-option>
          <a-select-option value="Android" key="android">Android</a-select-option>
        </a-select>
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="changeDate()" />
        <a-button type="primary" @click="downLoad">导出</a-button>
      </div>
      <a-table :columns="getTableColumns" id="show-table"
               style="height: 100%;"
               :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
               :rowKey="item=>item.date" :loading="tableLoad"
               :data-source="tableData" bordered :pagination="false">
        <template :slot="advertiser" slot-scope="text,recode" v-for="advertiser in advertiserList">
          <div v-if="recode.date!=='汇总'">{{ text }}</div>
          <a v-else @click="changeData(text,advertiser)">{{text}}</a>
        </template>
        <span style="cursor: pointer" :slot="'T'+advertiser" v-for="advertiser in advertiserList">
          <a-tooltip>
            <template slot="title" >
              {{$store.state.purchaseAccount[advertiser]}}
            </template>
            {{advertiser}}
          </a-tooltip>
        </span>
      </a-table>
    </a-card>
    <DataErrorDialog
      :show-dialog="changeDataShow"
      :base-info="changeDataInfo"
      @close-dialog="()=>{changeDataShow=false}"></DataErrorDialog>
  </div>
</template>

<script>
import {GetPurchaseSummary} from "../../api/v1/purchase_api";
import DataErrorDialog from "../../components/Business/Dialog/DataErrorDialog";

export default {
  name: "Index",
  components: {DataErrorDialog},
  data(){
    return {
      platform:'',
      country:'',
      date:['',''],
      tableLoad:false,
      tableData:[],
      advertiserList:[],
      scrollY:'',
      changeDataInfo:{},
      changeDataShow:false,
    }
  },
  computed: {
    getTableColumns(){
      let _table_columns = [{
        title: '日期',
        dataIndex: 'date',
        scopedSlots: { customRender: 'date' },
        align:'center'
      }]
      this.advertiserList.forEach(advertiser => {
        _table_columns.push({
          dataIndex: advertiser,
          slots: { title: 'T'+advertiser },
          scopedSlots: { customRender: advertiser },
          align:'center'
        })
      })
      _table_columns.push({
        title: '汇总',
        dataIndex: 'count',
        align:'center'
      })
      return _table_columns
    }
  },
  mounted() {
    this.init_table_data()
  },
  methods:{
    init_table_data(){
      GetPurchaseSummary({
        platform:this.platform,
        start:this.date[0],
        end:this.date[1]
      }).then(resp => {
        if (resp.code===200){
          this.date = resp.data.date
          this.advertiserList = resp.data.advertiser
          this.tableData = resp.data.list
        }
      })
    },
    changePlatform(){
      this.init_table_data()
    },
    changeDate(){
      this.init_table_data()
    },
    changeData(num,channel){
      this.changeDataInfo = {
        now_num:num,
        channel:channel,
        type:'purchase',
        start:this.date[0],
        end:this.date[1],
        change_num:0
      }
      this.changeDataShow = true
    },
    downLoad(){
      let name = "内购汇总数据"
      name += this.date[0]+"至"+this.date[1]+"的"
      this._export_cvs(Object.values(this.tableData),this.getTableColumns,name)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Purchase/Index.vue